module.exports = __webpack_public_path__ + "img/box3-img-1.6b57b8a8.png";